import * as React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import ContactUs from '../contactUs/ContactUs';
import './Help.scss';

import { IBuild, OS } from '@models';

interface IBuildDownloadInformation extends IBuild {
  downloadLink: string;
  md5Link: string;
}

export interface IHelpStateProps {
  builds: IBuildDownloadInformation[];
  content: string;
}

const Help: React.FC<IHelpStateProps> = ({ builds, content }) => {
  const { t } = useTranslation();

  const uploaderBuildName = (build: OS): string => {
    switch (build) {
      case 'win64':
        return t('help_uploaderAppWin64');
      case 'win32':
        return t('help_uploaderAppWin32');
    }
  };

  return (
    <div className='pt-3 help'>
      <h3>{t('common_help')}</h3>
      <Helmet>
        <title>{t('help_title')}</title>
      </Helmet>
      <hr className='mt-0' />
      <div className='row'>
        <div className='col-7'>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
          <div className='fcolor--primary-brand font-weight-semi-bold'>
            {t('help_downloadTitle')}
          </div>
          {builds.map(({ build, downloadLink, md5Link, version }) => (
            <div className='build clearfix' key={build}>
              <div className='float-left'>
                <a className='download-link' href={downloadLink}>
                  <i className='fas fa-arrow-circle-down fcolor--primary-brand mr-1'></i>
                  {uploaderBuildName(build)}
                </a>
              </div>
              <div className='float-right'>
                <a className='download-link' href={md5Link} download>
                  {t('help_md5')}
                </a>
                <span className='mx-1 fcolor--table-border'>|</span>
                <span>{t('help_version', { version })}</span>
              </div>
            </div>
          ))}
        </div>
        <div className='col-1' />
        <div className='col-4'>
          <div className='bg-color--light-blue px-4 pb-4 pt-3'>
            <ContactUs />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
